export enum RoutingStatusType {
  OffQueue = 'OFF_QUEUE',
  Idle = 'IDLE',
  Interacting = 'INTERACTING',
  NotResponding = 'NOT_RESPONDING',
  Communicating = 'COMMUNICATING'
}

export interface RoutingStatusNotification {
  id: string;
  routingStatus: {
    status: RoutingStatusType;
    startTime: string;
  };
}
